
import axios from 'axios';

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json', // En-tête Content-Type par défaut
  },
  timeout: 200000, // délai d'attente de 5 secondes
});

// Intercepteur pour gérer globalement les erreurs (optionnel)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Vous pouvez ajouter ici une logique de logging ou de transformation d'erreur
    return Promise.reject(error);
  }
);

export default apiClient;

